class AliquotaAntecipacaoController extends AbstractController
  @$inject = [ '$injector', '$scope', 'pathService', 'estadoService', 'aliquotaAntecipacaoService' ]

  constructor: ($injector, @scope, pathService, @estadoService, @aliquotaAntecipacaoService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/aliquota-antecipacao/"
    @loadingTracker = @promiseTracker()
    @modalMedicamentoListaItem = @openPopup(@url + "modal.html", 'aliquotaAntecipacaoModalController as ctrl')
    @modalImportar = @openPopup(@url + "importar.html", 'aliquotaAntecipacaoImportarController as ctrl')

    @listOfOperacao = [
      {id: '==', nome: 'Igual a'}
      {id: '!=', nome: 'Diferente de'}
      {id: '>', nome: 'Maior que'}
      {id: '>=', nome: 'Maior igual a'}
      {id: '<', nome: 'Menor que'}
      {id: '<=', nome: 'Menor igual a'}
    ]

    @filtro =
      page: 1,
      estado: 21 # rondônia

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfMedicamentoListaItem = []
    @listOfEstado = []
    @listOfEstadoOrigem = []

    @loadingTracker.addPromise @estadoService.getList((data) =>
      @listOfEstado = data
      @listOfEstadoOrigem = [{nome: "Todos os estados", id: "todos"}, @listOfEstado...]
    )

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @aliquotaAntecipacaoService.getList(filtro,(result) =>
      if result.success
        @listOfAliquotasAntecipacao = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de alíquotas.', 'Erro!', false)
    )


  add: ->
    @modalMedicamentoListaItem({
      aliquotaAplicacao: => {
        estado: @filtro.estado
        estadoOrigem: @filtro.estadoOrigem
      }
      listOfEstado: =>  @listOfEstado
      listOfOperacao: => @listOfOperacao
    }, (result) =>
      @loadData())

  edit: (aliquotaAplicacao) ->
    @modalMedicamentoListaItem({
      aliquotaAplicacao: => aliquotaAplicacao
      listOfEstado: =>  @listOfEstado
      listOfOperacao: => @listOfOperacao
    }, (result) =>
      @loadData())

  remover: (aliquota)->
    Confirm.warning('Atenção', "Deseja realmente remover a alíquota de antecipação ##{aliquota.id} - #{aliquota.estadoOrigem.sigla} - #{aliquota.estado.sigla}?", {
      Sim: =>
        @aliquotaAntecipacaoService.delete(aliquota.id, (result)=>
          if(result.success)
            Alert.success("A alíquota de antecipação ##{aliquota.id} - #{aliquota.estadoOrigem.sigla} - #{aliquota.estado.sigla} foi removido!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover a alíquota de antecipação ##{aliquota.id} - #{aliquota.estadoOrigem.sigla} - #{aliquota.estado.sigla}.")
        )
      Não: ''
    })

  baixar: () ->
    cbk.download '/api/eficiencia-fiscal/aliquota-antecipacao.csv'

  importar: ->
    @modalImportar({}, (result) =>
      @loadData()
    )

angular.module('eficienciaFiscalModule').controller('aliquotaAntecipacaoController', AliquotaAntecipacaoController)

class AliquotaAntecipacaoModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'aliquotaAntecipacaoService', 'aliquotaAplicacao', 'listOfEstado', 'listOfOperacao' ]

  constructor: ($injector, @modalInstance, @aliquotaAntecipacaoService, @aliquotaAplicacao, @listOfEstado, @listOfOperacao) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @observacao = ''
    @ncms = ''

    # clone para não bugar se abrir -> fechar modal -> abrir de novo
    @aliquotaAplicacao = $.extend({}, @aliquotaAplicacao)
    @aliquotaAplicacao.observacoes ?= []

    if !@aliquotaAplicacao.ncms # novo cadastro
        @aliquotaAplicacao.ncms =  []

    # ncms vem como array, mas editamos como string
    @aliquotaAplicacao.ncms = @aliquotaAplicacao.ncms.reduce (i, acc) ->
            acc + '\n' + i
        , ''

    # para o campo funcionar corretamente quando o item que possua
    # a flag todosEstados for editado, senão o campo viria limpo
    if @aliquotaAplicacao.todosEstados
        @aliquotaAplicacao.estadoOrigem = "todos"

    @listOfEstadoOrigem = [{nome: "Todos os estados", id: "todos"}, @listOfEstado...]

  addObservacao: ->
    @aliquotaAplicacao.observacoes.push {texto: @observacao}
    @observacao = ''

  removerObservacao: (index)->
    if(index > -1)
      @aliquotaAplicacao.observacoes.splice(index, 1)

  salvar: (form) ->
    if form.$valid
      # pros casos onde o usuário limpou o campo,
      # acontece com os produtos importados
      if @aliquotaAplicacao.estadoOrigem == ''
        @aliquotaAplicacao.estadoOrigem = null

      if @aliquotaAplicacao.estadoOrigem == 'todos'
        @aliquotaAplicacao.estadoOrigem = null
        @aliquotaAplicacao.todosEstados = true
      else
        @aliquotaAplicacao.todosEstados = false
        
      @submitTracker.addPromise @aliquotaAntecipacaoService.save(@aliquotaAplicacao, (data) =>
        Alert.success("Alíquota antecipada Nº  <strong>#{data.id}</strong> #{if @aliquotaAplicacao.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, data))
      )


angular.module('eficienciaFiscalModule').controller('aliquotaAntecipacaoModalController', AliquotaAntecipacaoModalController)


class AliquotaAntecipacaoImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader' ]

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/aliquota-antecipacao"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
      filters: [ {
        name: 'extFilter'
        fn: (item, options) =>
          extension = item.type == 'text/csv' || item.type == "application/vnd.ms-excel"
          @extension = !extension
          @uploader.clearQueue() unless extension
          document.getElementById('file').value = '' unless extension

          return extension
      } ]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>

      if response.success
        @Alert.success("O CSV de aliquotas de antecipação foi importado com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

angular.module('eficienciaFiscalModule').controller('aliquotaAntecipacaoImportarController', AliquotaAntecipacaoImportarController)
